import { useQuery } from "@tanstack/react-query";
import { useDepartmentFlags } from "@/hooks/useDepartmentFlags";
import { useErrorSnackbar } from "@/hooks/useErrorSnackbar";
import { backendService } from "@/services/backend.service";
import type { NurseData, RequestApprovalNursesParams } from "@/utils/models";

export const useRequestApproval = (params: RequestApprovalNursesParams) => {
	const showErrorSnackbar = useErrorSnackbar();
	const { isHospitalDemo } = useDepartmentFlags();

	return useQuery<NurseData[]>({
		queryKey: ["request_nurses_to_approve", params.requestId, params.departmentId],
		queryFn: async () => {
			const response = await backendService.getRequestNursesToApprove(params);
			return response.data;
		},
		throwOnError: (error: any) => {
			const message = error?.response?.status === 400 ? "Looks like the request is no longer active" : "Failed to find staff to approve";
			showErrorSnackbar(message, {}, error);
			return false;
		},
		gcTime: 0,
		enabled: !isHospitalDemo,
	});
};
